import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { convertArrayToObject } from "../../helpers/catalog-helper";
import { userNormalLogout, supportLogout } from "../actions";

export interface ItemSchedulesState {
  itemSchedulesDataMap: {};
}

const initialState: ItemSchedulesState = {
  itemSchedulesDataMap: {},
}

export const itemSchedulesSlice = createSlice({
  name: 'itemSchedule',
  initialState,
  reducers: {
    getAllItemSchedulesData: (state) => { },
    saveAllItemSchedulesData: (state, actions) => {
      state.itemSchedulesDataMap = actions.payload.response?convertArrayToObject(actions.payload.response, 'mid'):{};
    },
    deleteItemScheduleData: (state, actions) => { },
    saveItemScheduleData: (state, actions) => {},
    updateItemSchedulesMap:  (state, actions) => {
      let dataToUpdate:any = cloneDeep(state.itemSchedulesDataMap);
      dataToUpdate[actions.payload.key] = actions.payload.data;
      state.itemSchedulesDataMap = dataToUpdate;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const {
  getAllItemSchedulesData,
  saveAllItemSchedulesData,
  deleteItemScheduleData,
  saveItemScheduleData,
  updateItemSchedulesMap,

} = itemSchedulesSlice.actions;
export default itemSchedulesSlice.reducer;